import { createAsyncThunk } from '@reduxjs/toolkit'
import {
  getMttLobbyService,
  getMttOverviewService,
  getMttResultsService,
  registerMttService,
  unregisterMttService
} from 'network/services/mtt.service'

const errorMessage = (error, fallback) =>
  error?.response?.data?.message || error?.message || fallback

export const getMttLobbyThunk = createAsyncThunk(
  'mtt/getLobby',
  async (params = {}, { rejectWithValue }) => {
    try {
      return await getMttLobbyService(params)
    } catch (error) {
      return rejectWithValue(errorMessage(error, 'Failed to fetch MTT lobby'))
    }
  }
)

export const registerMttThunk = createAsyncThunk(
  'mtt/register',
  async ({ tournamentId }, { rejectWithValue }) => {
    try {
      const response = await registerMttService({ tournamentId })
      return { tournamentId, ...(response || {}) }
    } catch (error) {
      return rejectWithValue(errorMessage(error, 'Failed to register for MTT'))
    }
  }
)

export const unregisterMttThunk = createAsyncThunk(
  'mtt/unregister',
  async ({ tournamentId }, { rejectWithValue }) => {
    try {
      const response = await unregisterMttService({ tournamentId })
      return { tournamentId, ...(response || {}) }
    } catch (error) {
      return rejectWithValue(errorMessage(error, 'Failed to forfeit MTT entry'))
    }
  }
)

export const getMttOverviewThunk = createAsyncThunk(
  'mtt/getOverview',
  async (tournamentId, { rejectWithValue }) => {
    try {
      return await getMttOverviewService(tournamentId)
    } catch (error) {
      return rejectWithValue(errorMessage(error, 'Failed to fetch MTT overview'))
    }
  }
)

export const getMttResultsThunk = createAsyncThunk(
  'mtt/getResults',
  async ({ tournamentId, ...params } = {}, { rejectWithValue }) => {
    try {
      return await getMttResultsService(tournamentId, params)
    } catch (error) {
      return rejectWithValue(errorMessage(error, 'Failed to fetch tournament results'))
    }
  }
)
